@use '../../../../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../../../../styles/Colors.scss' as Colors;

.BillableWorkFieldList {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: flex-start;
	margin-top: Constants.$val-spacing-s;

	.list {
		flex: 1;
		overflow: hidden;
	}

	.workName {
		line-height: Constants.$val-spacing-l;
		font-size: Constants.$val-fontSizeRegular;
	}
}

.BillableWorkField {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	cursor: pointer;
	transition: color 0.1s;
	min-height: 24px;

	color: Colors.$col-greyDark;

	&:hover:not(.focused) {
		color: Colors.$col-blue;
	}

	&.highlighted {
		color: Colors.$col-blue;
	}

	&.focused {
		color: Colors.$col-orange;
	}

	.findIcon {
		font-size: Constants.$val-icon20;
		margin-right: Constants.$val-spacing-s;
		color: Colors.$col-blue;
	}

	.name {
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
	}

	.button {
		padding: 0;

		&.focused {
			color: Colors.$col-orange;
			font-weight: bold;
		}
	}
}
